import {
  ApplicationConfig,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  inject,
} from "@angular/core";
import { provideRouter, withRouterConfig, Router } from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { Capacitor } from "@capacitor/core";

import { routes } from "./app.routes";
import { provideIonicAngular } from "@ionic/angular";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { STORAGE_PORT } from "./core/auth/storage/storage.port";
import { LocalStoragePort } from "./core/auth/storage/local-storage.port";
import { BiometricService } from "./core/auth/services/biometric.service";
import { IdleService } from "./core/auth/services/idle.service";
import { AuthStore } from "./core/auth/auth.store";
import { TokenRefreshService } from "./core/auth/token-refresh.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withRouterConfig({ canceledNavigationResolution: "computed" }),
    ),
    provideIonicAngular({ mode: "md" }),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: LOCALE_ID, useValue: "es-MX" },
    { provide: STORAGE_PORT, useClass: LocalStoragePort },
    provideAppInitializer(async () => {
      // B universal deuda: quitar if(!isNative) return — gate universal forzaría login en web
      if (!Capacitor.isNativePlatform()) return;
      const svc = inject(BiometricService);
      const store = inject(AuthStore);
      const refresh = inject(TokenRefreshService);
      const router = inject(Router);
      let avail = false;
      try {
        avail = await svc.isAvailable();
      } catch {
        avail = false;
      }
      if (!avail) return;
      let hasVault = false;
      try {
        hasVault =
          (await svc.isEnrolled("staff")) ||
          (await svc.isEnrolled("socio"));
      } catch {
        hasVault = false;
      }
      if (!hasVault) return;
      store.clearSession();
      refresh.stopRefresh();
      try {
        sessionStorage.removeItem("tenso.idle.sessionAlive");
      } catch {}
      await router.navigate(["/login"], { replaceUrl: true });
    }),
    provideAppInitializer(async () => {
      const idle = inject(IdleService);
      await idle.init();
    }),
  ],
};
